import { DropDownView, FilterType } from '@gripp/shared-ui';
import { View } from 'react-native';
import { AddOnFilter } from './addOnFilter';

type AddOnFilterMenuProps = {
  onAddOnFilterOpen: () => void;
  onAddOnFilterClose: () => void;
  isOpened: boolean;
  anchorRef: React.RefObject<View>;
  type: FilterType;
};

export const AddOnFilterMenu = ({
  onAddOnFilterClose,
  onAddOnFilterOpen,
  isOpened,
  anchorRef,
  type,
}: AddOnFilterMenuProps) => {
  return (
    <DropDownView
      anchorRef={anchorRef}
      isVisible={isOpened}
      onDismiss={onAddOnFilterClose}
    >
      <AddOnFilter onCloseSideBar={onAddOnFilterClose} type={type} />
    </DropDownView>
  );
};
